import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBrostar = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 68,
	height: 68,
	viewBox: "0 0 68 68",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_97_281)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.2012 13.1191C7.74016 13.3633 1.2223 19.98 1.2223 27.8251C1.2223 35.9607 8.17641 42.556 16.7546 42.556L19.3128 42.012V57.2687H22.9861L23.2372 41.0263L25.205 33.2002L17.3655 26.9929C16.7905 26.5374 16.572 25.817 16.8085 25.1601C17.0465 24.5044 17.6903 24.0394 18.4507 23.976L28.8231 23.1258L32.9217 14.461C33.2225 13.8244 33.9113 13.4136 34.6776 13.4136C35.444 13.4136 36.1325 13.8244 36.4351 14.461L40.5338 23.1258L50.9046 23.976C51.665 24.0381 52.3102 24.5032 52.5467 25.1601C52.7833 25.8185 52.5645 26.5374 51.9897 26.9929L44.1502 33.2002L46.2258 41.4548L46.2351 41.4568V57.2687H49.9083V42.2585L51.271 42.556C59.9 42.556 66.8033 35.7899 66.8033 27.8251C66.8033 20.8269 61.7309 15.1917 55.463 13.6376C52.8507 5.55873 44.6593 -3.8147e-06 35.7386 -3.8147e-06C26.8179 -3.8147e-06 19.1261 5.42885 16.2012 13.1191ZM34.1472 37.5389L32.4828 38.9024L32.8859 63.1817H36.5592L36.156 38.9024L34.1472 37.5389ZM25.6738 42.3964L29.7502 40.291V66.6757H25.6738V42.3964ZM42.9202 42.1724L39.2469 39.8879L39.6501 66.4517H43.3233L42.9202 42.1724Z",
				fill: "url(#paint0_linear_97_281)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M27.6646 68C29.0253 68 30.1284 66.8969 30.1284 65.5362C30.1284 64.1755 29.0253 63.0724 27.6646 63.0724C26.3039 63.0724 25.2008 64.1755 25.2008 65.5362C25.2008 66.8969 26.3039 68 27.6646 68Z",
				fill: "#DA5D2F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.704 64.6915C36.0647 64.6915 37.1677 63.5884 37.1677 62.2277C37.1677 60.867 36.0647 59.764 34.704 59.764C33.3433 59.764 32.2402 60.867 32.2402 62.2277C32.2402 63.5884 33.3433 64.6915 34.704 64.6915Z",
				fill: "#D9D9D9"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M41.6729 68C43.0336 68 44.1366 66.8969 44.1366 65.5362C44.1366 64.1755 43.0336 63.0724 41.6729 63.0724C40.3122 63.0724 39.2091 64.1755 39.2091 65.5362C39.2091 66.8969 40.3122 68 41.6729 68Z",
				fill: "#DA5D2F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M48.3603 59.06C49.721 59.06 50.8241 57.957 50.8241 56.5963C50.8241 55.2356 49.721 54.1325 48.3603 54.1325C46.9996 54.1325 45.8965 55.2356 45.8965 56.5963C45.8965 57.957 46.9996 59.06 48.3603 59.06Z",
				fill: "url(#paint1_linear_97_281)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M34.704 64.6915C36.0647 64.6915 37.1677 63.5884 37.1677 62.2277C37.1677 60.867 36.0647 59.764 34.704 59.764C33.3433 59.764 32.2402 60.867 32.2402 62.2277C32.2402 63.5884 33.3433 64.6915 34.704 64.6915Z",
				fill: "url(#paint2_linear_97_281)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21.1884 59.06C22.5491 59.06 23.6522 57.957 23.6522 56.5963C23.6522 55.2356 22.5491 54.1325 21.1884 54.1325C19.8277 54.1325 18.7246 55.2356 18.7246 56.5963C18.7246 57.957 19.8277 59.06 21.1884 59.06Z",
				fill: "url(#paint3_linear_97_281)"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M13.6563 45.6853H29.706V48.9938H13.6563V45.6853Z",
				fill: "#DA5D2F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.3996 45.6853H39.4203V48.9938H55.3996V45.6853Z",
				fill: "#DA5D2F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.7412 49.8385C14.1019 49.8385 15.205 48.7354 15.205 47.3747C15.205 46.014 14.1019 44.911 12.7412 44.911C11.3805 44.911 10.2774 46.014 10.2774 47.3747C10.2774 48.7354 11.3805 49.8385 12.7412 49.8385Z",
				fill: "#DA5D2F"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M55.47 49.8385C56.8307 49.8385 57.9337 48.7354 57.9337 47.3747C57.9337 46.014 56.8307 44.911 55.47 44.911C54.1093 44.911 53.0062 46.014 53.0062 47.3747C53.0062 48.7354 54.1093 49.8385 55.47 49.8385Z",
				fill: "#DA5D2F"
			})
		]
	}), /* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear_97_281",
			x1: 34.0128,
			y1: -38147e-10,
			x2: 34.0128,
			y2: 66.6757,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", {
					offset: .0384615,
					stopColor: "#F29C1F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .442308,
					stopColor: "#DA5D2F"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .956731,
					stopColor: "#DA5D2F"
				})
			]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint1_linear_97_281",
			x1: 48.3603,
			y1: 54.1325,
			x2: 48.3603,
			y2: 59.06,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C6D5C1" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F29C1F"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint2_linear_97_281",
			x1: 34.704,
			y1: 59.764,
			x2: 34.704,
			y2: 64.6915,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C6D5C1" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F29C1F"
			})]
		}),
		/* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint3_linear_97_281",
			x1: 21.1884,
			y1: 54.1325,
			x2: 21.1884,
			y2: 59.06,
			gradientUnits: "userSpaceOnUse",
			children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#C6D5C1" }), /* @__PURE__ */ _jsx("stop", {
				offset: 1,
				stopColor: "#F29C1F"
			})]
		}),
		/* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_97_281",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 68,
				height: 68,
				fill: "white"
			})
		})
	] })]
});
export default SvgBrostar;
